// Helpers de fechas de eventos (extraídos de Agenda para no arrastrar
// la página Agenda ni VenueMap al chunk principal).
export const getEventDates = (e) => (e.dates && e.dates.length ? e.dates : (e.date ? [e.date] : []));
export const fmtEventDate = (d) => new Date(d).toLocaleDateString("es-ES", { day: "2-digit", month: "short" });
export const isPastDate = (d) => {
  const today = new Date(); today.setHours(0, 0, 0, 0);
  return new Date(d) < today;
};
export const hasUpcomingDate = (e) => getEventDates(e).some((d) => !isPastDate(d));
export const todayKey = () => {
  const t = new Date();
  return `${t.getFullYear()}-${String(t.getMonth() + 1).padStart(2, "0")}-${String(t.getDate()).padStart(2, "0")}`;
};
export const isTodayEvent = (e) => getEventDates(e).some((d) => (d || "").slice(0, 10) === todayKey());
export const nextUpcomingDate = (e) => {
  const up = getEventDates(e).filter((d) => !isPastDate(d)).sort();
  return up[0] || e.date || "";
};
